const moment = window.moment;

// Returns a human readable time ago date
export default function (value) {
  if (value) {
    return moment(value).tz(window.config.timezone).fromNow();
  }
  return "-";
}
